import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const SprayNozzel = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [spraynozzelUrl, setSpraynozzelUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    hex_face_to_face: "",
    hex_length: "",
    bottom_cyl_dia: "",
    bottom_cyl_height: "",
    top_cyl_dia: "",
    top_cyl_height: "",
    cone1_base_dia: "",
    cone1_top_dia: "",
    cone1_height: "",
    cone2_base_dia: "",
    cone2_top_dia: "",
    cone2_height: "",
    hole_dia: "",
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject <model-viewer>
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Submit design to create STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://www.d-rosa.ai/spraynozzeldesign",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
            user_email: userEmail,
            folder_path: folderName,
            hex_face_to_face: parseFloat(inputs.hex_face_to_face),
            hex_length: parseFloat(inputs.hex_length),
            bottom_cyl_dia: parseFloat(inputs.bottom_cyl_dia),
            bottom_cyl_height: parseFloat(inputs.bottom_cyl_height),
            top_cyl_dia: parseFloat(inputs.top_cyl_dia),
            top_cyl_height: parseFloat(inputs.top_cyl_height),
            cone1_base_dia: parseFloat(inputs.cone1_base_dia),
            cone1_top_dia: parseFloat(inputs.cone1_top_dia),
            cone1_height: parseFloat(inputs.cone1_height),
            cone2_base_dia: parseFloat(inputs.cone2_base_dia),
            cone2_top_dia: parseFloat(inputs.cone2_top_dia),
            cone2_height: parseFloat(inputs.cone2_height),
            hole_dia: parseFloat(inputs.hole_dia),
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setSpraynozzelUrl(data.spraynozzelurl || "");
        alert("Spray Nozzel design is completed!!");
      } else {
        console.error("Error sending Spray Nozzel data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP to GLB
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/SpraySteptoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting Spray Nozzel to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Spray Nozzel Design</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      {/* Form */}
      <form onSubmit={handleSubmit}>
        {Object.keys(inputs).map((key) => (
          <div key={key}>
            <input
              type="number"
              name={key}
              value={inputs[key]}
              onChange={handleChange}
              placeholder={key.replaceAll("_", " ")}
              className="w-full p-2 border rounded"
              required
            />
            <br />
            <br />
          </div>
        ))}
        <button type="submit" style={{ padding: "10px 20px", fontSize: "16px" }}>
          Submit
        </button>
      </form>

      <br />
      <p>Spray Nozzel File Path: {spraynozzelUrl}</p>
      <br />

      {spraynozzelUrl && (
        <>
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px", marginBottom: "10px" }}
          >
            View
          </button>
          <br />
          <a href={spraynozzelUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}>
              Download
            </button>
          </a>
        </>
      )}

      {/* Show 3D GLB */}
      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Spray Nozzel Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Spray Nozzel model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{
              width: "600px",
              height: "400px",
              backgroundColor: "grey",
            }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button
        onClick={() => navigate("/previous-page")}
        style={{ border: "none", background: "none" }}
      >
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section" style={{ textAlign: "center", marginTop: "20px" }}>
        <div style={{ fontSize: "14px" }}>
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default SprayNozzel;
